import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

// sel === null : tout est coché ; sinon tableau des valeurs cochées
export const inSel = (sel, v) => sel === null || sel.includes(v);

export const MultiFilter = ({ label, options, sel, onChange, testid, className = "w-48" }) => {
  const { t } = useI18n();
  const all = options.map((o) => o.value);
  const checked = (v) => inSel(sel, v);
  const toggle = (v, on) => {
    const cur = sel === null ? all : sel;
    const next = on ? [...new Set([...cur, v])] : cur.filter((x) => x !== v);
    onChange(all.every((x) => next.includes(x)) ? null : next);
  };
  const n = sel === null ? all.length : sel.filter((v) => all.includes(v)).length;
  const summary = sel === null ? t("Tous") : n === 0 ? t("Aucun") : n === 1 ? options.find((o) => o.value === sel.find((v) => all.includes(v)))?.label : `${n} / ${all.length}`;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className={`justify-between font-normal ${className} ${sel !== null ? "border-primary text-primary" : ""}`} data-testid={testid}>
          <span className="truncate"><span className="text-muted-foreground">{label} :</span> {summary}</span>
          <ChevronDown className="w-4 h-4 opacity-60 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 p-2" data-testid={`${testid}-menu`}>
        <div className="flex gap-1 mb-2">
          <Button size="sm" variant="ghost" className="h-7 flex-1 text-xs" onClick={() => onChange(null)} data-testid={`${testid}-all`}>{t("Tout cocher")}</Button>
          <Button size="sm" variant="ghost" className="h-7 flex-1 text-xs" onClick={() => onChange([])} data-testid={`${testid}-none`}>{t("Tout décocher")}</Button>
        </div>
        <div className="max-h-72 overflow-y-auto space-y-0.5">
          {options.map((o) => (
            <label key={o.value} className="flex items-center gap-2 rounded px-2 py-1.5 text-sm cursor-pointer hover:bg-muted" data-testid={`${testid}-opt-${o.value}`}>
              <Checkbox checked={checked(o.value)} onCheckedChange={(v) => toggle(o.value, !!v)} />
              <span className="truncate">{o.label}</span>
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
